import { Navigate } from 'react-router-dom';
import { useAuthStore } from './auth.store';
import { homeRouteForRole } from './home-route';

/**
 * Редирект на главную страницу пользователя по его роли.
 *
 * Используется:
 *  - catch-all `*` маршрут (App.tsx), чтобы не отправлять админа/менеджера
 *    в кабинет клиента (где он получит 403 на /clients/me).
 *  - index-маршруты /cabinet и /manager.
 *
 * Если пользователь не залогинен — отправляем на /login.
 */
export function HomeRedirect() {
  const user = useAuthStore((s) => s.user);
  const accessToken = useAuthStore((s) => s.accessToken);
  if (!accessToken || !user) {
    return <Navigate to="/login" replace />;
  }
  return <Navigate to={homeRouteForRole(user.role)} replace />;
}
